export default __webpack_public_path__ + "static/media/TraceyPanek.8ee9f9b8.png";